import { PozSubscriptionBillingPeriod } from './poz-subscription';

export class SubscriptionConfig {
  defaultProductSubscription?: number;
  defaultBillingPeriod: PozSubscriptionBillingPeriod =
    PozSubscriptionBillingPeriod.MONTHLY;
  showQuantity: boolean = false;
  generateInvoice?: boolean = true;
  // New subscriptions billed at the start of each period
  billInAdvance: boolean = false;
  paymentTermsDays: number = null;
  // The subscriptions are billed automatically when due
  autoBilling: boolean = false;
  sendInvoiceByEmail: boolean = false;
  // A sale of a subscription product to a customer starts its subscription
  createFromSale: boolean = true;
  endReminderEmail: boolean = false;
  endReminderSms: boolean = false;
  endReminderDays: number = 30;
}
